module.exports = __webpack_public_path__ + "img/FR18919.1aa328f7.png";